function openCity(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("content__container");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}

window.onload = function() {
  document.getElementsByClassName("tablinks")[0].click();
};



document.addEventListener("DOMContentLoaded", function() {
  
  document.querySelectorAll('.popup-trigger').forEach(function (item) {
    item.addEventListener('click',function(event){
      event.preventDefault();
      if (!event.target.classList.contains('vertical-product-card__button')) {
        item.querySelector('.vertical-product-card__button.hide__adc_btn').click();
      }
    })
  })
  
});

// Define the custom element
class MyCustomElement extends HTMLElement {
    constructor() {
      super();
       this.addEventListener('click', this.addtoBagclick);   
    }
    addtoBagclick() {
      if (this.hasAttribute('disable')) {
        return false;
      }
      this.getDesiredValues();
      this.updataPrices();
      this.removeLiIfexist();
      this.appenNewChild();
      
    }

    updataPrices(){
      this.originalPriceCon = document.querySelector('.product-price__cost .product-price__current-price');
      this.compatedPriceCon = document.querySelector('.product-price__cost .product-price__old-price');
      this.saleAmountCon = document.querySelector('.product-price__content .product__badge');
      //set new original price
      this.originalPriceValues = this.originalPriceCon.getAttribute('original_price');
      this.finalPriceOrg = parseInt(this.originalPriceValues) + parseInt(this.selPrdOriginalPrice);
      this.originalPriceCon.textContent = document.querySelector('.product-price__cost').getAttribute('currency') + parseInt(this.finalPriceOrg  / 100)+".00";
      
      console.log(document.querySelector('.product-price__cost').getAttribute('currency') + this.finalPriceOrg  / 100+".00");
       // console.log("original value: "+this.originalPriceValues+"final prices "+this.finalPriceOrg +"sail it prices:"+this.selPrdOriginalPrice);
     // set new compared price
      this.compatedPriceValues = this.compatedPriceCon.getAttribute('compred_price');
      this.finalPriceCmo = parseInt(this.compatedPriceValues) + parseInt(this.selPrdcompared_price);
      this.compatedPriceCon.textContent = document.querySelector('.product-price__cost').getAttribute('currency') + parseInt(this.finalPriceCmo  / 100)+".00";
      
     // set new sale  price
      this.saleAmountValues = this.saleAmountCon.getAttribute('sale_price_value');
      this.finalPriceSale = parseInt(this.saleAmountValues) + parseInt(this.saleAmountSelPrdPrice);
      this.saleAmountCon.textContent ="Save "+ document.querySelector('.product-price__cost').getAttribute('currency') + parseInt(this.finalPriceSale  / 100)+".00";

      // set new attribute values for con
      this.originalPriceCon.setAttribute('original_price',this.finalPriceOrg);
      this.compatedPriceCon.setAttribute('compred_price',this.finalPriceCmo);
      this.saleAmountCon.setAttribute('sale_price_value',this.finalPriceSale);

    }
   
    getDesiredValues(){
       this.prodcut_content_wrapper = this.closest('.product__content');
       this.varaintId = this.prodcut_content_wrapper.querySelector('product-form [name="id"]').getAttribute('value');
      var media_scr = this.prodcut_content_wrapper.querySelector('.product-media__image').getAttribute('src');
      // if (window.screen.width < 768) {
      //  this.productMediaElement = this.prodcut_content_wrapper.querySelector('.product-mobile-media .product-media__image');
      // }else{
      //  this.productMediaElement = this.prodcut_content_wrapper.querySelector('.product-desktop-media .product-media__image');
      // }
      // console.log("medai con: "+this.productMediaElement);
       // this.productMediaElement.classList.remove('shape__target-image', 'lazyautosizes', 'ls-is-cached', 'lazyloaded');
       // this.selectd_product_media = this.productMediaElement.outerHTML;
       this.selectd_product_media = `<img src="${media_scr}" />`;
       this.selected_product_title = this.prodcut_content_wrapper.querySelector('.product__info .h5').textContent;
       this.selPrdOriginalPrice = this.prodcut_content_wrapper.querySelector('.product-price__current-price').getAttribute('original_price1');
       this.selPrdcompared_price = this.prodcut_content_wrapper.querySelector('.product-price__old-price').getAttribute('compred_price1');
       this.saleAmountSelPrdPrice = this.prodcut_content_wrapper.querySelector('.product-price__content .product__badge').getAttribute('sale_price_value1');
       this.detector_class = this.getAttribute('tab_detect');
      // console.log('Wrapper: '+this.prodcut_content_wrapper+"Medai: "+this.selectd_product_media+"Title: "+this.selected_product_title+"Original Price: "+this.original_price);
    }
    
    appenNewChild(){
        this.selectedProductElement = document.createElement('li');
        // set attribute 
        this.selectedProductElement.setAttribute("Orinal_price", this.selPrdOriginalPrice);
        this.selectedProductElement.setAttribute("compared_price", this.selPrdcompared_price);
        this.selectedProductElement.setAttribute("Sale_price", this.saleAmountSelPrdPrice);
        this.selectedProductElement.setAttribute("var_id", this.varaintId);
      
        this.selectedProductElement.classList.add('popup-trigger');
        this.selectedProductElement.classList.add(this.getAttribute('tab_detect'));
        this.selectedProductElement.innerHTML = `${this.selectd_product_media}<p class="vertical-product-card__title">${this.selected_product_title}</p><remove-product class="remove_selected_product">Remove</remove-product>`;
        this.customDataDiv = document.querySelector(".custom__data__div");
        this.customDataDiv.appendChild(this.selectedProductElement);

        // change cart button text 
      var add_to_cart_button__span = document.querySelector('add-product-cart span');
   if (this.customDataDiv.children.length > 0) {
        var add_to_cart_button = document.querySelector('add-product-cart');
         document.querySelector('.product-price').classList.remove('hide_if_empty');
        add_to_cart_button__span.textContent = 'Add To Cart';
        add_to_cart_button.setAttribute('disable','false');
     
    } else {
     var add_to_cart_button = document.querySelector('add-product-cart');
      add_to_cart_button__span.textContent = 'Select the product';
      add_to_cart_button.setAttribute('disable','true');
         document.querySelector('.product-price').classList.add('hide_if_empty');
        
    } 
        this.prodcut_content_wrapper.querySelector('.quick-view__close-button').click();
      
    }
    
    removeLiIfexist(){
     var classChecker = this.detector_class;
     var selPrdOrdPrice = this.selPrdOriginalPrice;
     var selPrdComPrice = this.saleAmountSelPrdPrice;
     var selPrdSalePrice = this.saleAmountSelPrdPrice;
     this.ulElement = document.querySelector('.custom__data__div');
    if (this.ulElement && this.ulElement.querySelector('li')) {
         var isActive = false;
        this.ulElement.querySelectorAll('li').forEach(function(li) {
            if(li.classList.contains(classChecker)) {

              // update prices   
              var originalPriceCon = document.querySelector('.product-price__cost .product-price__current-price');
              var compatedPriceCon = document.querySelector('.product-price__cost .product-price__old-price');
              var saleAmountCon = document.querySelector('.product-price__content .product__badge');
              //set new original price
              var originalPriceValues = originalPriceCon.getAttribute('original_price');
              var finalPriceOrg = parseInt(originalPriceValues) - parseInt(li.getAttribute('orinal_price'));
              originalPriceCon.textContent = document.querySelector('.product-price__cost').getAttribute('currency') + parseInt(finalPriceOrg  / 100)+".00";
  
             // set new compared price
              var compatedPriceValues = compatedPriceCon.getAttribute('compred_price');
              var finalPriceCmo = parseInt(compatedPriceValues) - parseInt(li.getAttribute('compared_price'));
              compatedPriceCon.textContent = document.querySelector('.product-price__cost').getAttribute('currency') + parseInt(finalPriceCmo  / 100)+".00";
              
             // set new sale  price
              var saleAmountValues = saleAmountCon.getAttribute('sale_price_value');
              var finalPriceSale = parseInt(saleAmountValues) - parseInt(li.getAttribute('sale_price'));
              saleAmountCon.textContent ="Save "+ document.querySelector('.product-price__cost').getAttribute('currency') + parseInt(finalPriceSale  / 100)+".00";
  
              // set new attribute values for con
              originalPriceCon.setAttribute('original_price',finalPriceOrg);
              compatedPriceCon.setAttribute('compred_price',finalPriceCmo);
              saleAmountCon.setAttribute('sale_price_value',finalPriceSale);
                 li.remove();
            }
        }); 
    }   

  }
}


  // Define the custom element tag
  customElements.define('add-to-bag', MyCustomElement);

   class RemoveProduct extends HTMLElement {
      constructor() {
        super();
         this.addEventListener('click', this.removeProduct);   
      }
     removeProduct(){
       this.removed_li = this.closest('.popup-trigger');
       this.orgPrice   = this.removed_li.getAttribute('orinal_price');
       this.cmpPrice   = this.removed_li.getAttribute('compared_price');
       this.salePrice   = this.removed_li.getAttribute('sale_price');

        this.originalPriceCon = document.querySelector('.product-price__cost .product-price__current-price');
      this.compatedPriceCon = document.querySelector('.product-price__cost .product-price__old-price');
      this.saleAmountCon = document.querySelector('.product-price__content .product__badge');
      //set new original price
      this.originalPriceValues = this.originalPriceCon.getAttribute('original_price');
      this.finalPriceOrg = parseInt(this.originalPriceValues) - parseInt(this.orgPrice);
      this.originalPriceCon.textContent = document.querySelector('.product-price__cost').getAttribute('currency') + parseInt(this.finalPriceOrg  / 100)+".00";

     // set new compared price
      this.compatedPriceValues = this.compatedPriceCon.getAttribute('compred_price');
      this.finalPriceCmo = parseInt(this.compatedPriceValues) - parseInt(this.cmpPrice);
      this.compatedPriceCon.textContent = document.querySelector('.product-price__cost').getAttribute('currency') + parseInt(this.finalPriceCmo  / 100)+".00";
      
     // set new sale  price
      this.saleAmountValues = this.saleAmountCon.getAttribute('sale_price_value');
      this.finalPriceSale = parseInt(this.saleAmountValues) - parseInt(this.salePrice);
      this.saleAmountCon.textContent ="Save "+ document.querySelector('.product-price__cost').getAttribute('currency') + parseInt(this.finalPriceSale  / 100)+".00";

      // set new attribute values for con
      this.originalPriceCon.setAttribute('original_price',this.finalPriceOrg);
      this.compatedPriceCon.setAttribute('compred_price',this.finalPriceCmo);
      this.saleAmountCon.setAttribute('sale_price_value',this.finalPriceSale);

       this.removed_li.remove();
       // set the text for add to cart buttton
       this.customDataDiv = document.querySelector(".custom__data__div");
        var add_to_cart_button = document.querySelector('add-product-cart');
        var add_to_cart_button__span = document.querySelector('add-product-cart span');
        if (this.customDataDiv.children.length > 0) {
           document.querySelector('.product-price').classList.remove('hide_if_empty');
          
            add_to_cart_button__span.textContent = 'Add To Cart';
           add_to_cart_button.setAttribute('disable','false');
        } else {
            add_to_cart_button__span.textContent = 'Select the product';
                add_to_cart_button.setAttribute('disable','true');
           document.querySelector('.product-price').classList.add('hide_if_empty');
        }
       
     }

     }
    customElements.define('remove-product', RemoveProduct);

  class AddProductToCart extends HTMLElement {
      constructor() {
        super();
         this.addEventListener('click', this.addedProductToCart);   
      }
    addedProductToCart(){
      if (this.getAttribute('disable') === 'true') return;
      var current_button = this;
      this.classList.add('loading');

     this.ulElement = document.querySelector('.custom__data__div');
      var idString = Array.from(this.ulElement.querySelectorAll('li')).map(function(li) {
              return li.getAttribute('var_id');
        }).join(',');
      var idArray = idString.split(','); 

      var data = {
          items: idArray.map(function (variantId) {
            return {
              id: variantId,
              quantity: 1 
            };
          })
      };

fetch('/cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  },
  body: JSON.stringify(data)
})
.then(function(response) {
  if (response.ok) {
      //UPDATE DRAWER
        fetch(window.location.href)
        .then((response) => response.text())
        .then((data) => {
          var car__drawer = document.querySelector("cart-drawer");
          var tempDiv = document.createElement("div");
          tempDiv.innerHTML = data;
          var updatedContent = tempDiv.querySelector("cart-drawer").outerHTML;
          car__drawer.outerHTML = updatedContent;
          document.querySelector('sidebar-button .icon.header__icon[aria-label="Cart"]').click();
          current_button.classList.remove('loading');
        })
        .catch((error) => {
          console.log(error);
        });
    //update cart drawer END
    
  }
})
.catch(function(error) {
  console.error('Fetch error:', error);
});
      
    }

  }
  customElements.define('add-product-cart', AddProductToCart);

let varianPickers = document.querySelectorAll('variant-picker');
if(varianPickers.length > 0){
  const colors = {
    "blue":"#0437F2",
    "serene":"#B9C2D3",
    "white":"#FFFFFF",
"navy":"#041831",
"red":"#E60000",
"blue":"#1338be",
"black":"#000000",
"grey":"#c1c1c3",
"sand":"#E5DDCD",
"cream":"#F3EADD"
  }
  varianPickers.forEach(varianPicker => {
	 varianPicker.addEventListener("change", function (e) {
       setTimeout(() => {
         let selectedColor;
         let selectedSize;
         if(varianPicker.querySelector('dropdown-opener')){
           selectedColor = varianPicker.querySelector('dropdown-opener shape-swatch').dataset.color;
           selectedSize = varianPicker.querySelector('[option-picker-name="Size"] span').innerText;
         }
          else{
           selectedColor = varianPicker.querySelector('.color-swatch-select-parent.selected').dataset.value;
           selectedSize = varianPicker.querySelector('.pill.selected span').innerText;
         }
         let otherVarianPickers = Array.from(varianPickers).filter(picker => picker !== varianPicker);
         otherVarianPickers.forEach(otherVariantPicker => {
          	if(otherVariantPicker.querySelector('dropdown-opener')){
                otherVariantPicker.querySelector('dropdown-opener shape-swatch').dataset.color = selectedColor;
                otherVariantPicker.querySelector('dropdown-opener shape-swatch').style = `--gsc-color-swatch-value: ${colors[selectedColor]};`
                otherVariantPicker.querySelector('[option-picker-name="Size"] span').innerText = selectedSize;
         }
          else{
           otherVariantPicker.querySelector('.color-swatch-select-parent.selected') ? otherVariantPicker.querySelector('.color-swatch-select-parent.selected').classList.remove('selected') : null;
           const newColor = otherVariantPicker.querySelector(`.color-swatch-select-parent[data-value=${selectedColor}]`);
           newColor ? newColor.classList.add('selected') : null;
           otherVariantPicker.querySelector('color-swatches-picker span.product-variant-picker__option-active-color').innerText = selectedColor;
           otherVariantPicker.querySelector('.pill.selected') ? otherVariantPicker.querySelector('.pill.selected').classList.remove('selected') : null;
           const newSize = otherVariantPicker.querySelector(`.pill .pill__label[data-value="${selectedSize}"]`);
           newSize ? newSize.closest('label').classList.add('selected') : null;
         }
          });
   
      }, 10);
          
});
});

  
  
}



document.addEventListener('DOMContentLoaded', function() {
  var variantPickers = document.querySelectorAll('.product-variant-picker');

  variantPickers.forEach(function(variantPicker) {
    variantPicker.addEventListener('change', function(e) {
      var selectedColor;
      var selectedSize;

      // Get the selected color and size from the current variant picker
      if (variantPicker.querySelector('.color-swatch-select-parent.selected')) {
        selectedColor = variantPicker.querySelector('.color-swatch-select-parent.selected').dataset.value;
        selectedSize = variantPicker.querySelector('.pill.selected span').innerText;
      } else {
        selectedColor = variantPicker.querySelector('dropdown-opener shape-swatch').dataset.color;
        selectedSize = variantPicker.querySelector('[option-picker-name="Size"] span').innerText;
      }

      // Update other variant pickers with the selected color and size
      var otherVariantPickers = Array.from(variantPickers).filter(picker => picker !== variantPicker);
      otherVariantPickers.forEach(function(otherVariantPicker) {
        if (otherVariantPicker.querySelector('.color-swatch-select-parent.selected')) {
          // Update color
          otherVariantPicker.querySelector('.color-swatch-select-parent.selected').classList.remove('selected');
          var newColor = otherVariantPicker.querySelector(`.color-swatch-select-parent[data-value="${selectedColor}"]`);
          if (newColor) {
            newColor.classList.add('selected');
          }
          // Trigger click on the selected color
          newColor.click();
        } else {
          // Update color
          otherVariantPicker.querySelector('dropdown-opener shape-swatch').dataset.color = selectedColor;
          otherVariantPicker.querySelector('dropdown-opener shape-swatch').style.setProperty('--gsc-color-swatch-value', colors[selectedColor]);
        }

        // Update size
        otherVariantPicker.querySelector('.pill.selected').classList.remove('selected');
        var newSize = otherVariantPicker.querySelector(`.pill .pill__label[data-value="${selectedSize}"]`);
        if (newSize) {
          newSize.closest('label').classList.add('selected');
          // Trigger click on the selected size
          newSize.closest('label').click();
        }
      });
    });
  });
});

